import * as React from 'react'
import { Card } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { PositionNumber } from 'api/common/constants'
import { EarningResponse } from 'api/common/responses'
import earningsAPI from 'api/earnings'
import Footer from 'components/Footer'
import Header from 'components/Header'
import InputSelectField from 'components/InputSelectField'
import loginData from 'utilities/loginData'
import { KeyValue, positions, teams } from 'utilities/resources/options'
import { autoCast, dateFormatter, numberFormat } from 'utilities/typeUtility'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [positionNumber, setPositionNumber] = React.useState<string>(String(PositionNumber.MainPosition))
  const [monthAgo, setMonthAgo] = React.useState<string>(teams[0].key)
  const [earningsData, setEarningsData] = React.useState<EarningResponse>({ selectablePositions: [] })
  const [selectablePositions, setSelectablePositions] = React.useState<KeyValue[]>([])
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    }
  }, [navigate])
  React.useEffect(() => {
    earningsAPI(autoCast(positionNumber), Number(monthAgo), (response: EarningResponse) => {
      setEarningsData(response)
      setSelectablePositions(positions.filter(({ key }) => response.selectablePositions.includes(autoCast(key))))
    })
  }, [positionNumber, monthAgo])
  return (
    <>
      <Header title="組織管理" />
      <main>
        <section className="mx-4 my-5">
          <InputSelectField name="position" label="ポジション選択" items={selectablePositions} bold setValue={setPositionNumber} />
          <Card body className="border-0 mt-4">
            <div className="fw-bold">報酬取得権利確定課金</div>
            <hr className="my-2" />
            <div className="fw-bold">￥ {numberFormat(earningsData?.rewardConfirmationCharge)}</div>
            <Card className="border-0 mt-3" bg="content">
              <Card.Body className="px-3 py-2">
                <div className="note">更新日 {dateFormatter(earningsData?.updateAt, 'yyyy/MM/dd')}</div>
              </Card.Body>
            </Card>
          </Card>
        </section>
        <section className="mx-4 my-5">
          <h3 className="fw-bold">月次売上集計</h3>
          <div>過去2ヶ月までの月次確定売上額が確認できます。</div>
          <InputSelectField name="team" label="対象期間" items={teams} bold className="mt-1" setValue={setMonthAgo} />
          <Card className="border-0 mt-3" bg="disabled">
            <Card.Body className="p-2">
              <div className="note">更新日 {dateFormatter(earningsData?.targetUpdateAt, 'yyyy/MM/dd')}</div>
            </Card.Body>
          </Card>
          <Card body className="border-0 mt-3">
            <div className="fw-bold">バイナリー（左系列）</div>
            <div className="note">※ゲーム内課金です</div>
            <div className="note">※登録人数は累計の人数表示です</div>
            <hr className="my-2" />
            <div>
              {numberFormat(earningsData?.binaryLeftPeoples)}人 ／ <span className="fw-bold">￥ {numberFormat(earningsData?.binaryLeftAmount)}</span>
            </div>
          </Card>
          <Card body className="border-0 mt-3">
            <div className="fw-bold">バイナリー（右系列）</div>
            <div className="note">※ゲーム内課金です</div>
            <div className="note">※登録人数は累計の人数表示です</div>
            <hr className="my-2" />
            <div>
              {numberFormat(earningsData?.binaryRightPeoples)}人 ／ <span className="fw-bold">￥ {numberFormat(earningsData?.binaryRightAmount)}</span>
            </div>
          </Card>
          <Card body className="border-0 mt-3">
            <div className="fw-bold">パーソナルグループ</div>
            <div className="note">※ゲーム内課金です</div>
            <div className="note">※登録人数は累計の人数表示です</div>
            <hr className="my-2" />
            <div>
              {numberFormat(earningsData?.personalGroupPeoples)}人 ／ <span className="fw-bold">￥ {numberFormat(earningsData?.personalGroupAmount)}</span>
            </div>
          </Card>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
